import { IconButton, Divider, ListItemIcon, ListItemText, ListSubheader, Menu, MenuItem } from "@mui/material";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdLogout } from "react-icons/md";
import "./MainMenu.css";

const MainMenu = ({ handleLogout, selectOption }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleSelectOption = (option) => {
        selectOption(option);
        handleClose();
    }

    return (
        <>
            <IconButton
                onClick={handleClick}>
                <GiHamburgerMenu />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
            >   <ListSubheader>Organisations</ListSubheader>
                <MenuItem>
                    <NavLink to="/organizations" onClick={handleSelectOption} className="link">Création d'organisations</NavLink>
                </MenuItem>
                <MenuItem>
                    <NavLink to="/organizations/manage" onClick={handleSelectOption} className="link">Gestion des organisations</NavLink>
                </MenuItem>
                <Divider />
                <ListSubheader>Personnalisation</ListSubheader>
                <MenuItem>
                    <NavLink to="/customization" onClick={handleSelectOption} className="link">Projets</NavLink>
                </MenuItem>
                <MenuItem>
                    <NavLink to="/partners" onClick={handleSelectOption} className="link">Partenaires</NavLink>
                </MenuItem>
                <MenuItem>
                    <NavLink to="/infos" onClick={handleSelectOption} className="link">Infos</NavLink>
                </MenuItem>
                <Divider />
                <MenuItem>
                    <NavLink to="/comments" onClick={handleSelectOption} className="link">Commentaires</NavLink>
                </MenuItem>
                <MenuItem onClick={() => { handleLogout(); handleClose(); }}>
                    <ListItemIcon>
                        <MdLogout />
                    </ListItemIcon>
                    <ListItemText>Déconnexion</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
}

export default MainMenu;